import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { GlobalDataService } from './global-data.service';
import { ChampsFusionService } from './champs-fusion.service';
import { ChampsFusion } from '@core/models/champsFusion.model';
import { getChampFusionIdentityKey, isPaveAdresseField } from '@core/utils/champs-fusion.utils';

@Injectable({
  providedIn: 'root'
})
export class AdressesDestinatairesService {

  public form!: FormGroup;

  public controls: any;

  champFusion: string;

  availableChampsFusion: Array<any> = [];
  filteredAvailableChampsFusion: Array<any> = [];
  selectedChampsFusion: Array<any> = [];
  availableStandaloneChampsFusion: Array<any> = [];
  public selectionValidated = false;

  constructor(
    private _formBuilder: FormBuilder,
    public _GlobalDataService: GlobalDataService,
    public champsFusionService: ChampsFusionService
  ) {
    this.controls = {
      champFusion: new FormControl(this.champFusion, [
      ]),
    };
    this.form = this._formBuilder.group(this.controls);
  }

  public initialise() {
    const champsFusion = this._GlobalDataService.CampagneExt?.ChampsFusion || [];

    this.selectedChampsFusion = (champsFusion || []).filter(isPaveAdresseField);
    const persistedValidation = this._GlobalDataService.CampagneExt?.AdresseSelectionValidee;
    this.selectionValidated = persistedValidation === true ||
      (typeof persistedValidation === 'undefined' &&
        !!this._GlobalDataService.Campagne?.IdCampagne &&
        this.selectedChampsFusion.length > 0);
    const selectedKeys = new Set(
      this.selectedChampsFusion
        .map(cf => this.getChampFusionKey(cf))
        .filter((key): key is string => !!key)
    );

    if (this._GlobalDataService.isStandaloneContext()) {
      if ((this._GlobalDataService.availableEloquaChampsFusion || []).length > 0) {
        this.availableChampsFusion = (this._GlobalDataService.availableEloquaChampsFusion || []).map(cf => ({ ...cf }));
        this.filteredAvailableChampsFusion = this.availableChampsFusion.filter(
          acf => {
            const key = this.getChampFusionKey(acf);
            return !key || !selectedKeys.has(key);
          }
        );
      } else {
        this.updateChampFusion();
      }
    } else {
      this.availableChampsFusion = (this._GlobalDataService.availableEloquaChampsFusion || []).map(cf => ({ ...cf }));
      this.filteredAvailableChampsFusion = this.availableChampsFusion.filter(
        acf => {
          const key = this.getChampFusionKey(acf);
          return !key || !selectedKeys.has(key);
        }
      );
    }

    this.selectedChampsFusion = this.selectedChampsFusion.map(cf => ({ ...cf }));
    this.filteredAvailableChampsFusion = this.filteredAvailableChampsFusion.map(cf => ({ ...cf }));
  }

  public reset(): void {
    this.availableChampsFusion = [];
    this.filteredAvailableChampsFusion = [];
    this.selectedChampsFusion = [];
    this.availableStandaloneChampsFusion = [];
    this.selectionValidated = false;
    if (this._GlobalDataService.CampagneExt) {
      this._GlobalDataService.CampagneExt.AdresseSelectionValidee = false;
    }
    this.form.reset({}, { emitEvent: false });
  }

  public setChampFusionType() {
    this.selectedChampsFusion.forEach((value, index) => {
      /** (?) Pass by reference Typescript.
       * Problème:
       * Lorsqu'un champ fusion est présent côté personnalisation et pavé adresse, cette méthode va également modifier les attributs côté personnalisation.
       * Après appel upsert en DB, un seul champ fusion sera crée, celui côté perso. est perdu.
       * 
       * Modifier la valeur d'un attribut du champ fusion le déréférence côté personnalisation.
      */
      let copyFusion = JSON.parse(JSON.stringify(value));
      this.selectedChampsFusion[index] = copyFusion;
      this.selectedChampsFusion[index].IsPaveAdresse = "true";
      this.selectedChampsFusion[index].Sequence = index;
    });
  }

  public getChampFusionKey(champFusion: ChampsFusion): string | null {
    return getChampFusionIdentityKey(champFusion);
  }

  private updateChampFusion() {
    this.availableStandaloneChampsFusion = [];
    const campagne = this._GlobalDataService.Campagne;
    if (!campagne?.IdCampagne || campagne.importOption === 'sftp' || !campagne.importFile) {
      this.availableChampsFusion = [];
      this.filteredAvailableChampsFusion = [];
      this._GlobalDataService.availableEloquaChampsFusion = [];
      return;
    }
    this.champsFusionService.listChampsDisponibleStandalone().subscribe({
      next: (response) => {
        const contactFields = Array.isArray(response)
          ? response
          : (response?.ContactFields || response?.contactFields || []);
        for (let i = 0; i < contactFields.length; i++) {
          const CF: ChampsFusion = {
            Id: contactFields[i].Id,
            ChampFusion: contactFields[i].FieldName || contactFields[i].fieldName,
            internalName: contactFields[i].internalName,
          };
          this.availableStandaloneChampsFusion.push(CF);
        }
        this.availableChampsFusion = this.availableStandaloneChampsFusion.map(cf => ({ ...cf }));
        this._GlobalDataService.availableEloquaChampsFusion = this.availableChampsFusion.map(cf => ({ ...cf }));
        const selectedKeys = new Set(
          this.selectedChampsFusion
            .map(scf => this.getChampFusionKey(scf))
            .filter((key): key is string => !!key)
        );
        this.filteredAvailableChampsFusion = this.availableChampsFusion.filter(
          acf => {
            const key = this.getChampFusionKey(acf);
            return !key || !selectedKeys.has(key);
          }
        );
        this.selectedChampsFusion = this.selectedChampsFusion.map(cf => ({ ...cf }));
        this.filteredAvailableChampsFusion = this.filteredAvailableChampsFusion.map(cf => ({ ...cf }));
      },
      error: () => {
        this.availableChampsFusion = [];
        this.availableStandaloneChampsFusion = [];
        this._GlobalDataService.availableEloquaChampsFusion = [];
        this.filteredAvailableChampsFusion = [];
      }
    });
  }

  public deletePaveAdresseInFrontend() {
    // Vider selectedChampsFusion sur pavé adresse
    this.selectedChampsFusion = [];

    // Vider filteredAvailableChampsFusion
    this.filteredAvailableChampsFusion = [];

    // Vider availableChampsFusion
    this.availableChampsFusion = [];

    // Vider availableStandaloneChampsFusion
    this.availableStandaloneChampsFusion = [];
  }
}
